import React from "react";
import { useNavigate } from "react-router-dom";
import { FiSearch, FiSettings } from "react-icons/fi";
import { IoMdNotificationsOutline } from "react-icons/io";
import { HiOutlineClock } from "react-icons/hi";
import useAuth from "../useAuth";

export default function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const currentTime = new Date().toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  });
  const currentDate = new Date().toLocaleDateString("en-IN", {
    weekday: "short",
    year: "numeric",
    month: "short",
    day: "numeric",
  });

  const handleLogout = () => {
    let userRes = window.confirm("Are you sure, You want to logout?");

    if (userRes) {
      logout();
    } else return null;
  };

  return (
    <div className="px-6 py-4 bg-white border-b border-slate-200 shadow-sm">
      <div className="flex items-center justify-between">
        {/* Left: Breadcrumb & Search */}
        <div className="flex items-center space-x-6">
          <div className="hidden md:block">
            <div className="flex items-center space-x-2 text-sm">
              <span className="font-medium text-slate-700">Dashboard</span>
              <span className="text-slate-400">/</span>
              <span className="text-slate-500">Overview</span>
            </div>
            <h2 className="text-xl font-bold text-slate-900 mt-1">
              Welcome back, Administrator
            </h2>
          </div>

          <div className="relative">
            <FiSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400" />
            <input
              type="text"
              placeholder="Search schemes, reports..."
              className="pl-10 pr-4 py-2.5 bg-white border border-slate-300 rounded-lg 
              focus:ring-2 focus:ring-blue-500 focus:border-blue-500 
              text-slate-700 placeholder-slate-400 w-72 transition-all duration-200"
            />
          </div>
        </div>

        {/* Right: Actions */}
        <div className="flex items-center space-x-3">
          {/* Date & Time */}
          <div className="hidden lg:flex items-center space-x-2 bg-blue-50 px-3 py-2 rounded-lg border border-blue-100">
            <HiOutlineClock className="text-blue-600 text-lg" />
            <div className="text-right">
              <div className="text-sm font-medium text-slate-900">
                {currentTime}
              </div>
              <div className="text-xs text-slate-600">{currentDate}</div>
            </div>
          </div>

          {/* Notifications */}
          <button className="p-2.5 hover:bg-blue-50 rounded-lg relative transition-colors duration-200 group">
            <div className="relative">
              <IoMdNotificationsOutline className="text-xl text-slate-600 group-hover:text-blue-600" />
              <span className="absolute -top-0.5 -right-0.5 w-2.5 h-2.5 bg-red-500 rounded-full border border-white"></span>
            </div>
            <div className="absolute -bottom-10 right-0 bg-white text-slate-700 text-xs px-2 py-1 rounded shadow opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none whitespace-nowrap border border-slate-200">
              3 New Notifications
            </div>
          </button>

          {/* Settings */}
          <button className="p-2.5 hover:bg-blue-50 rounded-lg transition-colors duration-200 group">
            <FiSettings className="text-xl text-slate-600 group-hover:text-blue-600 transition-colors" />
            <div className="absolute -bottom-10 right-0 bg-white text-slate-700 text-xs px-2 py-1 rounded shadow opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none whitespace-nowrap border border-slate-200">
              Settings
            </div>
          </button>

          {/* Divider */}
          <div className="h-6 w-px bg-slate-300"></div>

          {/* User Profile */}
          <div className="relative group/profile">
            <button className="flex items-center space-x-3 p-1.5 hover:bg-blue-50 rounded-lg transition-colors duration-200">
              <div className="w-9 h-9 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center shadow-md">
                <span className="text-white font-bold text-sm">A</span>
              </div>

              <div className="hidden md:block text-left">
                <div className="capitalize text-sm font-semibold text-slate-900">
                  {user?.userType} User
                </div>
                <div className="text-xs text-slate-500">Super Admin</div>
              </div>

              <svg
                className="hidden md:block text-slate-500 w-4 h-4 group-hover/profile:text-blue-600 transition-colors"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </button>

            {/* Dropdown (stays open on hover of button OR dropdown) */}
            <div
              className="
      absolute right-0 top-12 w-48 bg-white text-slate-700 text-sm 
      rounded-lg shadow-xl border border-slate-200 
      opacity-0 group-hover/profile:opacity-100 
      pointer-events-none group-hover/profile:pointer-events-auto
      transition-opacity duration-200
    "
            >
              <div className="p-3 border-b border-slate-200">
                <div className="font-medium">Administrator</div>
                <div className="text-xs text-slate-500 mt-1">{user?.email}</div>
              </div>

              <div className="p-2">
                <button
                  className="w-full text-left px-3 py-2 hover:bg-blue-50 rounded cursor-pointer"
                  onClick={() => navigate("./profile")}
                >
                  My Profile
                </button>

                <button
                  className="w-full text-left px-3 py-2 hover:bg-blue-50 rounded cursor-pointer text-red-500 hover:text-red-600"
                  onClick={handleLogout}
                >
                  Logout
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
